import script from "./pop.vue?vue&type=script&setup=true&lang=js"
export * from "./pop.vue?vue&type=script&setup=true&lang=js"

import "./pop.vue?vue&type=style&index=0&id=143c34de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-143c34de"]])

export default __exports__